import { IMapMngr } from '../interfaces';
import { AppConfig } from '../../app.config';

export class FreeHandTool extends NeWMI.Tool.FreeHandTool {

  private cursor = 'crosshair';

  constructor(protected mapMngr: IMapMngr) {
    super();
    this.id = FreeHandTool.ID;
    this.on('creationFinished', this.onCreateFinished.bind(this));
  }

  protected onMapEvent(evt): void {
    if (evt.eventType == NeWMI.Map.Enums.EMapEvents.MouseDown ||
      evt.eventType == NeWMI.Map.Enums.EMapEvents.MouseUp ||
      evt.eventType == NeWMI.Map.Enums.EMapEvents.MouseDrag) {
      if (evt.button != 0) {
        // ignore any irrelevant mouse events
        return;
      }
    }
    super.onMapEvent(evt);
  }

  activate(oldTool?: NeWMI.Tool.Base.ATool): boolean {
    this.mapMngr.setCursor(this.cursor);
    // if (AppConfig.settings.map.esri)
    this.map.setNavigationMode({ pan: false }); // newmi-tbd
    return super.activate(oldTool);
  }

  private onCreateFinished() {
    this.mapMngr.setCursor(this.cursor);
  }

  static get ID() {
    return "Tool_EURON_FreeHandTool";
  }

}
